import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, Stack, Button } from "@mui/material";
import { api } from "../../api/api";
import { b2bLedger } from "../../api/urls";
// import { useSelector} from "react-redux";
import { toast } from "react-toastify";
import { CaptionsOffIcon } from "lucide-react";

const CreditDetails = () => {
  const { state: txn } = useLocation();
  // console.log(txn,"I am txnnnn")
  // const token = useSelector((state) => state.auth.token);

  const fieldMap = {
    paid_order_id: "Order ID",
    transaction_id: "Transaction ID",
    created_at: "Transaction Date",
    is_paid: "Bill Date Status",
    amount: "Total Payable",
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const handlepay = async () => {
    if (!txn?.id) {
      toast.error("Missing transaction ID");
      return;
    }

    try {
      const response = await api.post(`${b2bLedger}`, {
        payment: "razorpay",
        id: txn.id,
      });

      if (response.data?.pay) {
        window.open(response?.data?.pay);
      }
    } catch (error) {
      console.error(" Error in handlepay:", error);
      toast.error("Payment failed. Please try again.");
    }
  };

  if (!txn)
    return (
      <div className="h-[50vh] flex flex-col justify-center items-center">
        <div className="mb-2">
          <CaptionsOffIcon size={80}/>
        </div>
        No transaction data found.
      </div>
    );
  return (
    <Box sx={{ p: 4, maxWidth: 1300, mx: "auto", bgcolor: "#fff" }}>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 3, fontSize: "27px" }}
      >
        {txn.tagsused || "Transaction Details"}
      </Typography>

      <Box sx={{ mb: 2 }}>
        <Stack spacing={1}>
          {Object.entries(fieldMap).map(([key, label]) => (
            <Box
              key={key}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                py: 0.8,
                columnGap: 8,
              }}
            >
              <Typography sx={{ width: "40%", minWidth: 140 }} fontWeight={500}>
                {label}:
              </Typography>
              <Typography
                sx={{
                  width: "60%",
                  textAlign: "right",
                }}
              >
                {key === "created_at"
                  ? new Date(txn[key]).toLocaleString("en-IN")
                  : key === "amount"
                    ? `₹${Number(txn[key]).toFixed(2)}`
                    : txn[key] || "N/A"}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>

      {txn.tagsused === "CREDITS USED" && (
        <Button
          variant="contained"
          onClick={handlepay}
          fullWidth
          sx={{
            mt: 3,
            backgroundColor: "#000",
            color: "#fff",
            borderRadius: "6px",
            textTransform: "none",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "#333",
            },
          }}
        >
          Pay Bill
        </Button>
      )}
    </Box>
  );
};

export default CreditDetails;
